import { ContentType } from '../../pages/content-creation/content-creation';

export type ContentTypeMedia = { video: boolean; gps: boolean };

/**
 * Medias utilises par chaque type de contenu. Les fichiers charges restent en memoire
 * quand on change de type : cette table dit seulement lesquels sont lus pour le type courant.
 */
export const CONTENT_TYPE_MEDIA: Readonly<Record<ContentType, ContentTypeMedia>> = {
  scenic: { video: true, gps: true },
  coaching: { video: true, gps: false },
  'gps-only': { video: false, gps: true },
  workout: { video: false, gps: false },
  playlist: { video: false, gps: false },
};
